import { useEffect, useState, useRef, use } from "react";
import axios from "axios";
import { Container, Row, Col, Card, Form, Alert, Spinner, Table, Modal, Button, Badge } from "react-bootstrap";
import LineMonthSeries from "./LineMonthSeries";
import LineYearComparison from "./LineYearComparison";
import MorososModal from "./reportes/MorososModal";

export default function ReportesContables() {
    const [year, setYear] = useState(new Date().getFullYear());
    const [month, setMonth] = useState(new Date().getMonth() + 1);
    const [tipos, setTipos] = useState({});
    const [summary, setSummary] = useState(null);
    const [monthly, setMonthly] = useState([]);
    const [morosos, setMorosos] = useState([]);
    const [alert, setAlert] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showMorosos, setShowMorosos] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [search, setSearch] = useState("");
    const [yearComparisonData, setYearComparisonData] = useState([]);
    const [trimestre, setTrimestre] = useState("");

    const [monthlyStats, setMonthlyStats] = useState({
        total: 0,
        previous: 0,
        change: 0,
        morosos: 0
    });

    const getMesesPorTrimestre = (t) => {
        switch (parseInt(t)) {
            case 1: return [1, 2, 3];
            case 2: return [4, 5, 6];
            case 3: return [7, 8, 9];
            case 4: return [10, 11, 12];
            default: return [];
        }
    };
    const mesToNumber = {
        enero: 1,
        febrero: 2,
        marzo: 3,
        abril: 4,
        mayo: 5,
        junio: 6,
        julio: 7,
        agosto: 8,
        septiembre: 9,
        octubre: 10,
        noviembre: 11,
        diciembre: 12
    };



    const [yearComparison, setYearComparison] = useState({
        current: 0,
        previous: 0,
        change: 0
    });

    const nameCache = useRef({ tipos: {} });

    const mes = new Date().toLocaleString("es-CL", { month: "long" }).toUpperCase();

    const filteredMorosos = morosos.filter((m) => {
        const texto = search.toLowerCase();
        return (
            m.nombre?.toLowerCase().includes(texto) ||
            m.apellido?.toLowerCase().includes(texto) ||
            m.rut?.toLowerCase().includes(texto)
        );
    });

    const totalPages = Math.ceil(filteredMorosos.length / rowsPerPage);

    const paginatedMorosos = filteredMorosos.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );
    const totalRecaudado = summary?.total_monto?.[0]?.total_recaudado || 0;
    const totalPagos = summary?.total_monto?.[0]?.pagos_count || 0;

    const totalSocios = morosos.length + totalPagos;
    const tasaMorosidad = totalSocios > 0
        ? ((morosos.length / totalSocios) * 100).toFixed(1)
        : 0;

    const cumplimiento = totalSocios > 0
        ? ((totalPagos / totalSocios) * 100).toFixed(1)
        : 0;

    const morosidadColor = tasaMorosidad > 30 ? "danger" : tasaMorosidad > 15 ? "warning" : "success";
    const cumplimientoColor = cumplimiento < 70 ? "danger" : cumplimiento < 85 ? "warning" : "success";

    const formatMoney = (n) =>
        new Intl.NumberFormat("es-CL", {
            style: "currency",
            currency: "CLP",
            minimumFractionDigits: 0,
        }).format(n || 0);


    const getUltimoMesPagado = (pagos = []) => {
        if (!pagos.length) return "N/A";
        const sorted = [...pagos].sort((a, b) => a.año - b.año || a.mes - b.mes);
        const last = sorted[sorted.length - 1];
        return `${last.mes}/${last.año}`;
    };

    const mesesOrdenados = [
        "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
        "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ];
    const mesesTrimestre = getMesesPorTrimestre(trimestre);

    const monthlyFiltrado = trimestre
        ? monthly.filter((m) => mesesTrimestre.includes(mesToNumber[m.mes.toLowerCase()]))
        : monthly;

    useEffect(() => {
    if (!monthly || monthly.length === 0) return;

    let meses = [];

    if (trimestre) {
        meses = getMesesPorTrimestre(trimestre);
    } else {
        // 🔥 TODO el año
        meses = [1,2,3,4,5,6,7,8,9,10,11,12];
    }

    const dataFiltrada = monthly.filter((m) =>
        meses.includes(mesToNumber[m.mes])
    );

    const total = dataFiltrada.reduce(
        (acc, m) => acc + Number(m.total),
        0
    );

    setMonthlyStats({
        total,
        previous: 0,
        change: 0,
        morosos: morosos.length
    });

}, [monthly, trimestre, morosos]);


    const monthlyNormalized = mesesOrdenados
        .filter((mes) => {
            if (!trimestre) return true;
            return mesesTrimestre.includes(mesToNumber[mes.toLowerCase()]);
        })
        .map((mes) => {
            const found = monthlyFiltrado.find(
                (m) => m.mes === mes.toLowerCase()
            );

            return {
                mes,
                total: found ? Number(found.total) : 0
            };
        });


    // useEffect(async () => {
    //   const tiposRes = await axios.get("https://socios.kolpingchile.cl/backend/api/tipos");

    //   const tiposMap = {};
    //   tiposRes.data.forEach(t => {
    //     tiposMap[t.id] = t.nombre;
    //   });

    //   setTipos(tiposMap);
    // }, []);

    useEffect(() => {
        async function fetchAll() {
            setLoading(true);
            try {

                let meses = [];

                if (trimestre) {
                    meses = getMesesPorTrimestre(trimestre);
                } else {
                    const now = new Date();
                    meses = [now.getMonth() + 1]; // comportamiento actual
                }

                // 🔥 Traer datos por múltiples meses si hay trimestre
                const morososRequests = meses.map(m =>
                    axios.get(`https://socios.kolpingchile.cl/backend/api/reportes/morosos/${year}/${m}`)
                );

                const morososResponses = await Promise.all(morososRequests);

                // 🔥 Unificar morosos (sin duplicados por RUT)
                const morososMap = new Map();

                morososResponses.forEach(res => {
                    (res.data.morosos || []).forEach(m => {
                        morososMap.set(m.rut, m);
                    });
                });

                const morososFinal = Array.from(morososMap.values());

                // 🔥 resto normal
                const [summaryRes, monthlyRes, tiposRes] = await Promise.all([
                    axios.get(`https://socios.kolpingchile.cl/backend/api/reportes/${year}`),
                    axios.get(`https://socios.kolpingchile.cl/backend/api/reportes/monthly/${year}`),
                    axios.get(`https://socios.kolpingchile.cl/backend/api/tipos`)
                ]);

                const tiposMap = {};
                tiposRes.data.forEach(t => {
                    tiposMap[t.id] = t.nombre;
                });

                setSummary(summaryRes.data);
                setMonthly(monthlyRes.data.months || []);
                setTipos(tiposMap);
                setMorosos(morososFinal);

            } catch (e) {
                console.error(e);
                setAlert("⚠️ Error al cargar datos");
            } finally {
                setLoading(false);
            }
        }

        fetchAll();
    }, [year, trimestre]);

    function interpret(data) {
        if (!data || data.length < 2) return;
        const curr = parseFloat(data.find((d) => d.periodo === "current")?.total || 0);
        const prev = parseFloat(data.find((d) => d.periodo === "previous")?.total || 0);

        if (prev > 0) {
            const change = ((curr - prev) / prev) * 100;
            if (change < -5)
                setAlert(`⚠️ Caída de ${change.toFixed(1)}% en recaudación`);
            else if (change > 5)
                setAlert(`✅ Aumento de ${change.toFixed(1)}% en recaudación`);
            else
                setAlert(`ℹ️ Recaudación estable`);
        }
    }

    return (
        <Container fluid className="py-4">
            {/* Year Filter */}
            <Row className="mb-4 align-items-end">
                <Col xs={12} sm={6} md={3}>
                    <Form.Group>
                        <Form.Label className="fw-bold">Año</Form.Label>
                        <Form.Select
                            value={year}
                            onChange={(e) => setYear(parseInt(e.target.value))}
                        >
                            {Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i).map((y) => (
                                <option key={y} value={y}>{y}</option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                </Col>
                <Col xs={12} sm={6} md={3}>
                    <Form.Group>
                        <Form.Label className="fw-bold">Trimestre</Form.Label>
                        <Form.Select
                            value={trimestre || ""}
                            onChange={(e) =>
                                setTrimestre(e.target.value)
                            }
                        >
                            <option value="">Todo el año</option>
                            <option value="1">Q1 (Ene - Mar)</option>
                            <option value="2">Q2 (Abr - Jun)</option>
                            <option value="3">Q3 (Jul - Sep)</option>
                            <option value="4">Q4 (Oct - Dic)</option>
                        </Form.Select>
                    </Form.Group>
                </Col>
            </Row>

            {/* Alert */}
            {/* {alert && <Alert variant="info" className="shadow-sm mb-4">{alert}</Alert>} */}

            {/* Loading State */}
            {loading ? (
                <div className="text-center py-5">
                    <Spinner animation="border" role="status" />
                    <p className="mt-3 text-muted">Cargando datos...</p>
                </div>
            ) : (
                <>

                    <h2 className="fw-bold mb-4">Resumen {year}</h2>

                    {/* Summary Cards */}
                    <Row className="g-3 mb-4">
                        {/* Total Recaudado */}
                        <Col xs={12} sm={6} lg={3}>
                            <Card className="shadow-sm border-0 rounded-4 h-100">
                                <Card.Body>
                                    <small className="text-muted d-block mb-2">Total Recaudado</small>
                                    <Badge bg="success" style={{ fontSize: "1.5rem" }} className="fw-bold mb-2">{formatMoney(totalRecaudado)}</Badge>
                                    {/* <span className="text-success small">↑ 12% vs mes anterior</span> */}
                                    <div className={`small ${yearComparison.change > 0 ? 'text-success' :
                                        yearComparison.change < 0 ? 'text-danger' :
                                            'text-warning'
                                        }`}>
                                        {yearComparison.change > 0 ? '▲' : '▼'} {yearComparison.change.toFixed(1)}%
                                        <span className="text-muted"> vs año anterior</span>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* Pagos */}
                        <Col xs={12} sm={6} lg={3}>
                            <Card className="shadow-sm border-0 rounded-4 h-100">
                                <Card.Body>
                                    <small className="text-muted d-block mb-2">Pagos Registrados</small>
                                    <Badge bg="primary" style={{ fontSize: "1.5rem" }} className="fw-bold">
                                        {totalPagos}
                                    </Badge>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* Morosidad */}
                        <Col xs={12} sm={6} lg={3}>
                            <Card className="shadow-sm border-0 rounded-4 h-100">
                                <Card.Body>
                                    <small className="text-muted d-block mb-2">Tasa de Morosidad</small>
                                    <Badge bg={morosidadColor} style={{ fontSize: "1.5rem" }} className="fw-bold">
                                        {tasaMorosidad}%
                                    </Badge>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* Cumplimiento */}
                        <Col xs={12} sm={6} lg={3}>
                            <Card className="shadow-sm border-0 rounded-4 h-100">
                                <Card.Body>
                                    <small className="text-muted d-block mb-2">Cumplimiento</small>
                                    <Badge bg={cumplimientoColor} style={{ fontSize: "1.5rem" }} className="fw-bold">
                                        {cumplimiento}%
                                    </Badge>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>


                    {/* Details Row */}
                    <Row className="g-3 mb-4">
                        {/* Cuotas Especiales */}
                        <Col xs={12} lg={4}>
                            <Card className="shadow-sm border-0 h-100">
                                <Card.Body>
                                    <Card.Title className="fw-bold mb-3">Resumen Mensual</Card.Title>
                                    <p className="text-muted mb-4">
                                        {trimestre
                                            ? `Trimestre ${trimestre}`
                                            : `Año completo`}
                                    </p>
                                    <hr />
                                    <Row className="g-4 mb-4">

                                        {/* 💰 Recaudación mes */}
                                        <Col md={12}>
                                            <Card className="shadow-sm border-0 rounded-4">
                                                <Card.Body>
                                                    <small className="text-muted">Recaudación</small>
                                                    <h4 className="fw-bold">{formatMoney(monthlyStats.total)}</h4>
                                                    <span className={`small ${monthlyStats.change >= 0 ? 'text-success' : 'text-danger'}`}>
                                                        {monthlyStats.change >= 0 ? '▲' : '▼'} {monthlyStats.change.toFixed(1)}%
                                                    </span>
                                                </Card.Body>
                                            </Card>
                                        </Col>

                                        {/* 📉 Mes anterior */}
                                        {/* <Col md={6}>
                                            <Card className="shadow-sm border-0 rounded-4">
                                                <Card.Body>
                                                    <small className="text-muted">Recaudación Mes anterior</small>
                                                    <h4 className="fw-bold">{formatMoney(monthlyStats.previous)}</h4>
                                                </Card.Body>
                                            </Card>
                                        </Col> */}

                                        {/* ⚠️ Morosos */}
                                        <Col md={12}>
                                            <Card className="shadow-sm border-0 rounded-4">
                                                <Card.Body>
                                                    <small className="text-muted">Morosos mes</small>
                                                    <h4 className="fw-bold text-danger">{monthlyStats.morosos}</h4>
                                                </Card.Body>
                                            </Card>
                                        </Col>



                                    </Row>

                                </Card.Body>
                            </Card>
                        </Col>

                        {/* Monthly Chart */}
                        <Col xs={12} lg={8}>
                            <Card className="shadow-sm border-0 h-100">
                                <Card.Body>
                                    <Card.Title className="fw-bold mb-3">Ingresos Mensuales</Card.Title>
                                    {monthly.length > 0 ? (
                                        <LineMonthSeries data={monthlyNormalized} year={year} />
                                    ) : (
                                        <p className="text-muted text-center py-4">Sin datos disponibles</p>
                                    )}
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    <Row className="mt-4">
                        <Col md={12}>
                            <Card className="shadow-sm border-0">
                                <Card.Body>
                                    <Card.Title className="fw-bold">Comparación Año vs Año</Card.Title>

                                    {yearComparisonData.length > 0 ? (
                                        <LineYearComparison data={yearComparisonData} year={year} />
                                    ) : (
                                        <p className="text-muted">Sin datos</p>
                                    )}

                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    {/* Morosos Section */}
                    <Row className="g-3 mt-3">
                        <Col xs={12}>
                            <Card className="shadow-sm border-0">
                                <Card.Body className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                                    <div>
                                        <Card.Title className="fw-bold mb-0">Morosos</Card.Title>
                                        <p className="text-muted mb-0">Total: {morosos.length}</p>
                                    </div>
                                    <Button
                                        onClick={() => setShowMorosos(true)}
                                        variant="primary"
                                        size="sm"
                                    >
                                        Ver Detalle
                                    </Button>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    {/* Morosos Modal */}
                    <MorososModal
                        show={showMorosos}
                        onHide={() => setShowMorosos(false)}
                        morosos={morosos}
                        tipos={tipos}
                    />
                </>
            )}
        </Container>
    );
}
